import type {
  GetObjectivesResponse,
  Objective as ApiObjective,
  StickyTree,
} from "@/backend/natsstubs/board/models";

import type { ServerObjective, ServerObjectiveStickyTree, ServerObjectives } from "../serverModel";

/** `objectives.get` answers the legacy `objective.list` shape: two ranked lists, `objective_id` as `id`. */
export function mapApiBoardObjectives(response: GetObjectivesResponse): ServerObjectives {
  return {
    objectives: response.objectives.map(mapApiBoardObjective),
    stretches: response.stretches.map(mapApiBoardObjective),
  };
}

/** @internal exported for tests */
export function mapApiBoardObjective(objective: ApiObjective): ServerObjective {
  return {
    objective_id: objective.id,
    text: objective.text,
    description: objective.description ?? "",
    ...(objective.bv !== undefined && { bv: objective.bv }),
    // The server drops a null `av`; legacy carried it as null.
    av: objective.av ?? null,
    rag: objective.rag,
    stickies: objective.stickies?.map((sticky) => ({ id: sticky.id, is_origin: sticky.isOrigin })),
    ...(objective.linkedObjectives && {
      linked_objectives: objective.linkedObjectives.map((linked) => ({
        id: linked.id,
        board_id: linked.boardId,
      })),
    }),
    ...(objective.stickyTree && { sticky_tree: mapApiStickyTree(objective.stickyTree) }),
  };
}

function mapApiStickyTree(tree: StickyTree): ServerObjectiveStickyTree {
  return {
    stickies: tree.stickies,
    status_distribution: tree.statusDistribution,
    status_distribution_state: tree.statusDistributionState,
  };
}
